import { handleError } from "../../../../utils/helpers";
import { salesBaseApi } from "../../../api";
import { AdminLoginPayload } from "../../admin/auth/auth.types";
import { SalesLoginResponse, SalesSingleAgent } from "./auth.types";

export const salesAuthApi = salesBaseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    salesSignup: builder.mutation<SalesLoginResponse, AdminLoginPayload>({
      query: (payload) => {
        return {
          url: "sales/create-password",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    salesLogin: builder.mutation<SalesLoginResponse, AdminLoginPayload>({
      query: (payload) => {
        return {
          url: "sales/login",
          method: "POST",
          body: { ...payload },
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
    getSingleAgent: builder.query<SalesSingleAgent, { email: string }>({
      query: (params) => {
        const { email } = params;
        return {
          url: `sales/agent-details/${email}`,
          method: "GET",
        };
      },
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (err) {
          handleError(err);
        }
      },
    }),
  }),
});

export const {
  useSalesLoginMutation,
  useSalesSignupMutation,
  useGetSingleAgentQuery,
} = salesAuthApi;
